export enum PasswordResetRequestStatus
{
    New,
    Requested,
    Completed,
    Canceled,
    Expired
};